import type { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
} from '@/components/atoms';

interface TwoFactorDialogWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: ReactNode;
  onBack?: () => void;
  onContinue?: () => void;
  continueLabel?: string;
  continueDisabled?: boolean;
  isLoading?: boolean;
  showBackButton?: boolean;
}

export const TwoFactorDialogWrapper = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  onBack,
  onContinue,
  continueLabel = 'Continue',
  continueDisabled = false,
  isLoading = false,
  showBackButton = false,
}: TwoFactorDialogWrapperProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex flex-col max-h-[90vh] p-0">
        {/* Fixed Header */}
        <DialogHeader className="text-left p-4 border-b shrink-0">
          <DialogTitle className="text-primary font-bold text-base md:text-lg">
            {title}
          </DialogTitle>
          {description && (
            <DialogDescription className="text-xs md:text-sm lg:text-base text-gray-700">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-4">{children}</div>

        {/* Fixed Footer */}
        {(showBackButton || onContinue) && (
          <DialogFooter className="flex gap-2 px-6 pb-6 pt-4 border-t shrink-0">
            {showBackButton && onBack && (
              <Button variant="outline" onClick={onBack}>
                Back
              </Button>
            )}
            {onContinue && (
              <Button
                className="bg-primary text-white hover:bg-primary/90"
                onClick={onContinue}
                disabled={continueDisabled}
                isLoading={isLoading}
              >
                {continueLabel}
              </Button>
            )}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
